// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.grey[600]
        },
        // Do not set `top` / tight lineHeight here — MUI positions outlined labels with `transform`;
        // extra offsets broke vertical centering of input and select values.
        outlined: {
          '&.MuiInputLabel-shrink': {
            background: theme.vars.palette.background.paper,
            padding: '0 8px',
            marginLeft: -6
          }
        }
      }
    }
  };
}
